import { useState } from "react";

export default function CTASection() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get("website_alt");
    if (honeypot && String(honeypot).trim() !== "") {
      setStatus("success");
      setEmail("");
      return;
    }
    if (!email.trim()) {
      setErrorMsg("请输入邮箱地址");
      setStatus("error");
      return;
    }
    setStatus("loading");
    setErrorMsg("");
    try {
      const res = await fetch(
        "https://readdy.ai/api/form/d96bfkn0d76aer3t52fg",
        {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({ email: email.trim() }).toString(),
        }
      );
      const responseText = await res.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      if (res.ok && parsed?.code === "OK") {
        setStatus("success");
        setEmail("");
      } else {
        const serverMsg =
          parsed?.meta?.message || parsed?.message || responseText || "订阅失败";
        if (
          typeof serverMsg === "string" &&
          serverMsg.toLowerCase().includes("spam")
        ) {
          setStatus("success");
          setEmail("");
          return;
        }
        setErrorMsg(serverMsg);
        setStatus("error");
      }
    } catch {
      setErrorMsg("网络错误，请稍后重试");
      setStatus("error");
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <div className="relative rounded-2xl overflow-hidden h-48 md:h-64 mb-10">
            <img
              src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20newsroom%20with%20warm%20lighting%2C%20stacked%20newspapers%20and%20laptop%20on%20wooden%20desk%2C%20cozy%20atmosphere%2C%20cinematic%20photography%2C%20film%20grain%20texture%2C%20journalism%20aesthetic%2C%20rich%20warm%20tones&width=1200&height=600&seq=cta-newsletter-bg&orientation=landscape"
              alt="订阅每日爆料"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-black/30"></div>
          </div>

          <div className="text-center mb-8">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              不想错过<span className="italic text-foreground-600 font-normal">任何一个</span>
              <span className="text-primary-500">大瓜</span>？
            </h2>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed">
              订阅911吃瓜网每日爆料，最新网红翻车、明星黑料直送你的邮箱
            </p>
          </div>

          <form
            onSubmit={handleSubmit}
            data-readdy-form
            id="newsletter-form"
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="hp-field"
            />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (status === "error") setStatus("idle");
              }}
              placeholder="输入你的邮箱地址"
              required
              className="flex-1 px-5 py-3 rounded-full bg-background-50 border border-background-300 text-sm text-foreground-950 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
            />
            <button
              type="submit"
              disabled={status === "loading"}
              className="px-8 py-3 rounded-full bg-foreground-950 text-white text-sm font-medium hover:bg-foreground-800 transition-colors disabled:opacity-60 whitespace-nowrap cursor-pointer"
            >
              {status === "loading" ? "订阅中..." : "立即订阅"}
            </button>
          </form>

          {status === "success" && (
            <p className="text-center text-sm text-primary-500 mt-4">
              订阅成功！最新爆料将第一时间送达你的邮箱
            </p>
          )}
          {status === "error" && (
            <p className="text-center text-sm text-primary-500 mt-4">
              {errorMsg || "订阅失败，请稍后重试"}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}